import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const publicStatsApi = createApi({
  reducerPath: "publicStats",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getPublicStats: builder.query({
      query: () => ({ url: "/api/public/stats", method: "GET" }),
    }),
  }),
});

export const { useGetPublicStatsQuery } = publicStatsApi;
